import { MutableRefObject, useLayoutEffect } from 'react';

const useMenuPlacement = (ref: MutableRefObject<HTMLElement | null>, childIndex: number) => {
  // eslint-disable-next-line sonarjs/cognitive-complexity
  useLayoutEffect(() => {
    const child = ref.current?.children[childIndex] as HTMLElement;
    const dropdown = ref.current;

    if (dropdown && child && document.body) {
      const { left: dropdownLeft, right: dropdownRight, width: dropdownWidth } = dropdown.getBoundingClientRect();
      const { right: bodyRight, left: bodyLeft, width: bodyWidth } = document.body.getBoundingClientRect();
      const { width: columnWidth } = child.getBoundingClientRect();
      const remainingSpaceFromRight = bodyRight - dropdownLeft;
      const remainingSpaceFromLeft = dropdownRight - bodyLeft;
      const middle = (dropdownRight - dropdownLeft) / 2;

      if (columnWidth >= bodyWidth) {
        child.style.left = '0px';
        dropdown.style.position = 'unset';
        child.style.maxWidth = '100%';
      }

      if (columnWidth > remainingSpaceFromRight) {
        if (columnWidth < remainingSpaceFromRight + middle) {
          if (columnWidth > remainingSpaceFromLeft) {
            child.style.left = '50%';
            // eslint-disable-next-line sonarjs/no-duplicate-string
            child.style.transform = 'translateX(-50%)';
            dropdown.style.position = 'unset';
          } else {
            child.style.left = '50%';
            child.style.transform = 'translateX(-50%)';
          }
        } else {
          if (columnWidth > remainingSpaceFromLeft) {
            child.style.left = '50%';
            child.style.transform = 'translateX(-50%)';
            dropdown.style.position = 'unset';
          } else {
            child.style.right = '100%';
            child.style.transform = `translateX(${dropdownWidth}px)`;
          }
        }
      }
    }
  }, [ref, childIndex]);

  return null;
};

export default useMenuPlacement;
